import React from 'react';

const formats = [
  { key: 'pdf', label: 'PDF' },
  { key: 'excel', label: 'Excel' },
  { key: 'csv', label: 'CSV' }
];

const ReportDownloadButtons = ({ onDownload, disabled }) => {
  return (
    <div className="flex flex-wrap gap-3 mb-4">
      {formats.map(fmt => (
        <button
          key={fmt.key}
          type="button"
          onClick={() => onDownload(fmt.key)}
          disabled={disabled}
          className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-md border border-gray-300 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Download {fmt.label}
        </button>
      ))}
    </div>
  );
};

export default ReportDownloadButtons;
